import { DITypes, IOptions } from "@/core/@types/types";
import Result from "@/core/common/Result";
import { IUsuarioPorEmpresaUseCase } from "../ports/UsuarioPorEmpresaUseCase";
import { inject, injectable } from "inversify";
import {
  type IUsuariosPorEmpresaGateway,
  usuariosPorEmpresaGatewayDI
} from "../ports/UsuarioPorEmpresaGateway";
import "reflect-metadata";
import type { IToastNotification } from "@/composables/shared/notification/types";

@injectable()
export class UsuarioPorEmpresaUseCase implements IUsuarioPorEmpresaUseCase {
  constructor(
    @inject(usuariosPorEmpresaGatewayDI)
    private readonly gateway: IUsuariosPorEmpresaGateway,
    @inject(DITypes.NOTIFICATION)
    private readonly notification: IToastNotification<string>
  ) {}

  async createList(empresasId: string[]): Promise<Result<IOptions[]>> {
    const usuariosResult = await this.gateway.getUsers(empresasId);

    if (usuariosResult.isFailure) {
      this.notification.showNotification(usuariosResult.error, {
        type: "error"
      });

      return Result.fail(usuariosResult.error);
    }

    const options: IOptions[] = usuariosResult.getValue().map((usuario) => ({
      value: usuario.id,
      label: usuario.nome || "-"
    }));

    return Result.ok(options);
  }
}
